import React from 'react';

const MainContent = () => {
  return (
    <div className="flex-grow flex items-end justify-center pb-10 ">
      <h1 className="text-xl md:text-5xl font-bold font-syncopate lg:px-5 px-10 pb-24">Scale Every Human for the New A.I. World.</h1>
    </div>
  );
};

export default MainContent;
